/**
 * Swiper-based horizontal tab navigation for wd-tabs-content (navigation_swiper).
 * Patches TabsComponent.scrollToActiveButton so active tab stays in view.
 */
(function () {
  function patchTabsScrollToActiveButton() {
    const TC = customElements.get('tabs-component');
    if (!TC || TC.prototype.__wdTabNavSwiperScrollPatch) return;
    TC.prototype.__wdTabNavSwiperScrollPatch = true;
    const original = TC.prototype.scrollToActiveButton;
    TC.prototype.scrollToActiveButton = function (toButton) {
      const swRoot = this.querySelector('.wd-tabs-nav-swiper');
      const sw = swRoot ? swRoot.swiper : null;
      if (sw && toButton) {
        const idx = this.buttons.indexOf(toButton);
        if (idx >= 0) sw.slideTo(idx, 280);
        return;
      }
      return original.call(this, toButton);
    };
  }

  function foxCarouselDepsReady() {
    return !!(
      window.FoxTheme &&
      window.FoxTheme.Carousel &&
      window.FoxTheme.Swiper &&
      window.FoxTheme.Swiper.Swiper &&
      window.FoxTheme.Swiper.Navigation &&
      window.FoxTheme.Swiper.Pagination &&
      window.FoxTheme.Swiper.A11y
    );
  }

  /**
   * Section script can run before deferred theme.js. Retry via rAF; then if `load` already fired
   * (`document.readyState === 'complete'`), run callback immediately so init never stalls.
   */
  function whenFoxCarouselReady(callback) {
    if (foxCarouselDepsReady()) {
      callback();
      return;
    }
    let frames = 0;
    const maxFrames = 150;
    function tick() {
      if (foxCarouselDepsReady()) {
        callback();
        return;
      }
      if (frames++ < maxFrames) {
        requestAnimationFrame(tick);
        return;
      }
      if (document.readyState === 'complete') {
        callback();
        return;
      }
      window.addEventListener(
        'load',
        function onLoad() {
          window.removeEventListener('load', onLoad);
          callback();
        },
        { once: true }
      );
    }
    requestAnimationFrame(tick);
  }

  function initSwiperForRoot(root) {
    const el = root.querySelector('.wd-tabs-nav-swiper');
    if (!el || el._wdTabNavSwiperInited) return;
    if (!foxCarouselDepsReady()) return;

    if (window.FoxTheme.config && window.FoxTheme.config.isRTL) {
      el.setAttribute('dir', 'rtl');
    } else {
      el.removeAttribute('dir');
    }

    const wrap = el.closest('.tabs__nav-wrap');
    const prevEl = wrap && wrap.querySelector('.swiper-button-prev.wd-tabs-nav-swiper__nav-fallback');
    const nextEl = wrap && wrap.querySelector('.swiper-button-next.wd-tabs-nav-swiper__nav-fallback');

    const swiperModules = [
      window.FoxTheme.Swiper.Navigation,
      window.FoxTheme.Swiper.Pagination,
      window.FoxTheme.Swiper.A11y,
    ];
    if (window.FoxTheme.Swiper.Mousewheel) {
      swiperModules.push(window.FoxTheme.Swiper.Mousewheel);
    }

    let carousel;
    try {
      carousel = new window.FoxTheme.Carousel(
        el,
        {
          modules: swiperModules,
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: true,
          grabCursor: true,
          threshold: 8,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resistanceRatio: 0.65,
          pagination: false,
          navigation: {
            prevEl: prevEl || undefined,
            nextEl: nextEl || undefined,
          },
          mousewheel: window.FoxTheme.Swiper.Mousewheel
            ? {
                enabled: true,
                forceToAxis: true,
              }
            : undefined,
        },
        null
      );
      carousel.init();
      const slider = carousel.slider;
      if (slider && typeof slider.update === 'function') {
        requestAnimationFrame(function () {
          slider.update();
        });
      }
    } catch (e) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[wd-tabs-nav-swiper] Swiper init failed', e);
      }
      return;
    }

    el._wdTabNavSwiperInited = true;
    el._wdTabNavCarousel = carousel;
    const tabs = el.closest('tabs-component');
    if (tabs && carousel.slider) {
      const idx = Number.parseInt(tabs.getAttribute('data-selected'), 10);
      carousel.slider.slideTo(Number.isFinite(idx) ? idx : 0, 0);
    }
  }

  function initAll(scope) {
    patchTabsScrollToActiveButton();
    const root = scope && scope.nodeType === 1 ? scope : document;
    root.querySelectorAll('tabs-component[data-wd-tab-nav-swiper]').forEach((tabs) => {
      initSwiperForRoot(tabs);
    });
  }

  function scheduleInitAll(scope) {
    whenFoxCarouselReady(function () {
      initAll(scope);
    });
  }

  function destroyIn(scope) {
    const root = scope && scope.nodeType === 1 ? scope : document;
    root.querySelectorAll('.wd-tabs-nav-swiper').forEach((el) => {
      const slider = el._wdTabNavCarousel && el._wdTabNavCarousel.slider;
      if (slider && typeof slider.destroy === 'function') {
        try {
          slider.destroy(true, true);
        } catch (e) {
          /* noop */
        }
      }
      el._wdTabNavCarousel = null;
      el._wdTabNavSwiperInited = false;
    });
  }

  function boot() {
    scheduleInitAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const t = event.target;
    if (t && t.querySelector && t.querySelector('tabs-component[data-wd-tab-nav-swiper]')) {
      scheduleInitAll(t);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const t = event.target;
    if (t && t.querySelector && t.querySelector('.wd-tabs-nav-swiper')) {
      destroyIn(t);
    }
  });
})();
